import { createAction, props } from '@ngrx/store'

export const setIsLoading = createAction('[Core] Set is loading', props<{ payload: boolean }>())

export const setLockedIsLoading = createAction('[Core] Set locked loading status', props<{ payload: boolean }>())

export const lockIsLoading = createAction('[Core] Set lock loading status')
